import {
    API_VERSION,
    AUTH_SERVICE_DOMAIN,
    AUTH_SERVICE_PATH,
} from "../config/axios";
import axios from "../utility/authAxios";
import { ROLE_TYPES } from "../utility/constants";
import { setHttpParams } from "../utility/utils";

export const getUserInfo = async (id) => {
    return axios.get(`${API_VERSION}/user/${id}`);
};

export const getAuthUserDetails = async () => {
    return axios.get(API_VERSION + "/user");
};

const AUTH_SERVICE_URI = `${API_VERSION}/${AUTH_SERVICE_PATH}/${AUTH_SERVICE_DOMAIN}`;

export const getUsers = async (params = {}) => {
    params = setHttpParams(params);
    return axios.get(`${AUTH_SERVICE_URI}/search?${params}`);
};

export const changePassword = async (data) => {
    return axios.patch(`${AUTH_SERVICE_URI}/change-password`, data);
};

export const resetPassword = async (data, id) => {
    return axios.patch(`${AUTH_SERVICE_URI}/reset-password/${id}`, data);
};

export const getAgentUsers = async (params = {}) => {
    return axios.get(
        `${API_VERSION}/${AUTH_SERVICE_PATH}/agent/search?${setHttpParams(
            params
        )}`
    );
};

export const getCounterUsers = async (params = {}) => {
    return axios.get(
        `${API_VERSION}/${AUTH_SERVICE_PATH}/${AUTH_SERVICE_DOMAIN}/search?${setHttpParams(
            {
                ...params,
                ...{ "details.role_type": ROLE_TYPES.COMPANY_COUNTER },
            }
        )}`
    );
};

export const getRetailers = async (params = {}) => {
    return axios.get(
        `${API_VERSION}/${AUTH_SERVICE_PATH}/${AUTH_SERVICE_DOMAIN}/search?${setHttpParams(
            {
                ...params,
                ...{ "details.role_type": ROLE_TYPES.COMPANY_RETAILER },
            }
        )}`
    );
};

export const getCustomers = async (params = {}) => {
    params = setHttpParams(params);
    return axios.get(
        `${API_VERSION}/${AUTH_SERVICE_PATH}/customer/search?${params}`
    );
};

export const createCustomer = async (payload) => {
    return axios.post(
        `${API_VERSION}/${AUTH_SERVICE_PATH}/customer/register`,
        payload
    );
};
